import { FirebaseService } from 'src/app/services/firebase.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global.service';
import { ChooseClientComponent } from 'src/app/shared/choose-client/choose-client.component';

@Component({
  selector: 'app-create-pdr-account',
  templateUrl: './create-pdr-account.component.html',
  styleUrls: ['./create-pdr-account.component.scss'],
  standalone: false
})
export class CreatePdrAccountComponent implements OnInit {
    name = '';
    email = '';
    password = '';
    accountType = '';
    copyAccountId = '';
    copyAccountName = '';

    test = false;
    dellen = false;
    audatexUntilActive = false;
    audatexUntilDate = new Date().toISOString();
    audatex = false;
    multiUser = false;
    planer = false;
    mietwagen = false;
    win = false;
    testBis = new Date(Date.now() + +86400000 * 30).toISOString();

    constructor(
        public glo: GlobalService,
        public firebaseService: FirebaseService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<CreatePdrAccountComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: { leadId: string; email: string; name: string; clientType: string; clientSize: number },
    ) {}

    ngOnInit() {
        if (this.data.email) {
            this.email = this.data.email.trim();
        }
        if (this.data.name) {
            this.name = this.data.name.trim();
        }
        if (this.data.clientType) {
            this.accountType = 'modular';
            if (this.data.clientSize > 1) {
                this.multiUser = true;
            }
            if (this.data.clientType === 'delle') {
                this.dellen = true;
            }
            if (this.data.clientType === 'kul') {
                if (this.data.clientSize > 4) {
                    this.accountType = 'kul';
                }
            }
            if (this.data.clientType === 'kulm') {
                if (this.data.clientSize > 4) {
                    this.accountType = 'kulm';
                }
            }
        }
    }

    async createPdrAccount() {
        this.glo.startLoading();
        let testBis = 0;
        const extraModule: any = {
            multiUser: this.multiUser,
            dellen: this.dellen,
            planer: this.planer,
            mietwagen: this.mietwagen,
            win: this.win,
        };
        if (this.audatexUntilActive && this.audatexUntilDate && !this.audatex) {
            extraModule.audatexUntil = new Date(this.audatexUntilDate).getTime();
        }
        if (this.audatex) {
            extraModule.audatex = true;
        }
        if (this.test && this.testBis) {
            testBis = new Date(this.testBis).getTime();
        }
        let copyAccountId = '';
        if (this.copyAccountId) {
            copyAccountId = this.copyAccountId;
        }
        console.log('copyAccountId: ' + copyAccountId);
        try {
            const res = await this.firebaseService.requestCreateNewAccount(
                this.email.trim(),
                this.name,
                this.password,
                this.accountType,
                this.data.leadId || '',
                extraModule,
                testBis,
                copyAccountId,
            );
            console.log(res);
            this.glo.endLoading();
            if (res && res.result === 'ok') {
                this.glo.alert('Account erfolgreich angelegt!');
                this.dialogRef.close();
            }
            if (res && res.result === 'Emailadresse bereits vergeben!') {
                console.log('e');
                this.glo.alert('Emailadresse bereits vergeben!');
            }
            if (res && res.result === 'error') {
                throw new Error('error');
            }
        } catch (e) {
            console.log(e);
            this.glo.endLoading();
            this.glo.alert('Unbekannter Fehler!');
        }
    }

    selectCopyKunde() {
        const cfg = new MatDialogConfig();
        cfg.width = '600px';
        const dialogRef = this.dialog.open(ChooseClientComponent, cfg);
        dialogRef.afterClosed().subscribe((choosen) => {
            if (choosen && choosen.client) {
                this.copyAccountId = choosen.client.clientId;
                this.copyAccountName = choosen.client.name;
            }
            // console.log('The dialog was closed');
        });
    }

    clearCopyKunde() {
        this.copyAccountId = '';
        this.copyAccountName = '';
    }
}
